export const monthlySheetStatus = {
  approvedFrontline: 'approved_frontline',
  rejectedFrontline: 'rejected_frontline',
  reviewFrontline: 'review_frontline',
}

export const extraBottomSpacingDetailPage = 28
